import React, {Component} from "react";
import './Contact.css'
import Operator from  '../../../Assets/img/operator.png'
import Header from '../../Hoc/Header'
import Footer from '../../Hoc/Footer'



export default class ContactUs extends Component { 
    
 

    render() {
        return(


            <div className="contact">
                <Header title="درباره ما"/>
                <div className="contact-fix">
                     

                <div className="contact-body">

                    <div className="contact-header">

                        <div className="contact-header-pic">

                        <img src={Operator} alt="Resume"/>

                        </div>

                        <h3>راه های ارتباطی تماس با موسسه ما</h3>

                
                    </div>

                    <div className='contact-text'>
                        <span>
                            آدرس:اتوبان ستاری جنوب بعد از همت بلوار لاله بین ستاری و پژوهنده پلاک 20 
                            <br/><br/>
                           تلفن دفتر مرکزی 
                           <br/><br/>
                            021-91098002
                            <br/><br/>
                            (20 خط ویژه)
                            <br/><br/>
                           ایمیل :
                            <br/>
                            info@arianaabroad.com
                        </span>
                    </div>

                    

                   

 

               
 
            </div>

            <Footer/>
                </div>

     

        </div>
        )
    }


}